import styles from './table.module.scss';
import { useTranslation } from 'react-i18next';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { TableFooter, TableSortLabel } from '@mui/material';

import _ from 'lodash';
import parse from 'html-react-parser';
import { useEffect, useState } from 'react';
import { IconWrapper, formatHumanDate, formatToMaxFourDigits } from '@flexo/general';

import { useSelector } from 'react-redux';
import { RIGHT_DRAWER, store } from '@flexo/reducers';


export function InvoicesPeriodTable(props: any) {

  const { t } = useTranslation();
  const dispatch = store.dispatch;
  const metadata = useSelector((state: any) => state.metadata);
  const rightDrawer = useSelector((state: any) => state.rightDrawer);

  const { subtitle,no_data_text, rows } = t(`widgets.tables.InvoicesPeriodTable`, {
    returnObjects: true,
  }) as any;

  const title = t('widgets.tables.InvoicesPeriodTable.title', { communityName: metadata.selectedEntity?.communityName });

  const columns = rows;

  const [storedRows, setStoredRows] = useState<Array<any>>([]);
  const [rowsOrder, setRowsOrder] = useState(['period', 'asc']);

  useEffect(() => {

    const tableData = props.data.map((period: any, periodIndex: number) => ({
      index: periodIndex,
      period: period.period,
      amount: period.sites.reduce((acc: number, site: any) => acc + site.amount, 0),
      received: period.sites.reduce((acc: number, site: any) => acc + (site?.paid ? site.amount : 0), 0),
      paid: `${period.sites.filter((site: any) => site?.paid).length}/${period.sites.length}`,
      start_period: period.sites[0].period_start_date,
      ...period,
    }) );

    setStoredRows(tableData);
  }, [props.data]);

  function sortRows(columnId: string) {
    try {
      let _midArray = [...storedRows];
      let direction = 'asc';

      if (rowsOrder[0] === columnId && rowsOrder[1] === 'asc') {
        direction = 'desc';
      }

      switch (columnId) {
        case 'amount':
          _midArray = _midArray.sort((a, b) =>
            (
              direction === 'asc'
                ? a.amount > b.amount
                : a.amount < b.amount
            )
              ? 1
              : -1
          );
          break;
        case 'received':
          _midArray = _midArray.sort((a, b) =>
            (direction === 'asc' ? a.received > b.received : a.received < b.received)
              ? 1
              : -1
          );
          break;
        case 'paid':
          _midArray = _midArray.sort((a, b) =>
            (
              direction === 'asc'
                ? a.paid > b.paid
                : a.paid < b.paid
            )
              ? 1
              : -1
          );
          break;
        case 'period':
          _midArray = _midArray.sort((a, b) => {
            const d1 = new Date(a.start_period);
            const d2 = new Date(b.start_period);
            return (direction === 'asc' ? d1 > d2 : d1 < d2) ? 1 : -1;
          });
          break;
      }

      setRowsOrder([columnId, direction]);
      setStoredRows(_midArray);
    } catch (err: any) {
      // console.warn(err)
    }
  }

  return (
    <div>
      {/* {LOADING_STATE === 'PENDING' && <Shimmer />} */}
      {
        storedRows?.length > 0 ? (
        <div className={ styles.Table__InvoicesPeriods__OverflowContainer }>
        <div
          className={`${styles.Table} ${styles.Table__Flex} ${styles.Table__InvoicesPeriods}`}
          
            >
              
          <div>
            <div className={`${styles.Table__InvoicesPeriods__Title}`}>{parse(title)}</div>
            <div className={`${styles.Table__InvoicesPeriods__Subtitle}`}>{subtitle}</div>
                <div
                  className={`${styles.Table__InvoicesPeriods__Close}`}
                  onClick={() => {
                    dispatch(RIGHT_DRAWER.ResetDrawer())
                  }}
                >
                  <IconWrapper iconName="cross" />
                </div>
          </div>

          <TableContainer component={Paper} className={``}>
            <Table aria-label="simple table">
              <TableHead>
                <TableRow>
                  {columns &&
                    columns.map((column: any, column_i: number) => (
                      <TableCell
                        className={`
                ${
                  column.sortable
                    ? styles.Table__Header__Cell__Sortable
                    : styles.Table__Header__Cell__Static
                }
              ${
                column.sortable && rowsOrder[0] === column.field
                  ? styles.Table__Header__Cell__Active
                  : styles.Table__Header__Cell
              }`}
                        key={`invoices_periods_table_${column_i}`}
                      >
                        <TableSortLabel
                          active={
                            column.sortable && rowsOrder[0] === column.field
                          }
                          direction={
                            rowsOrder[0] === column.field &&
                            rowsOrder[1] === 'asc'
                              ? 'asc'
                              : 'desc'
                          }
                          onClick={() =>
                            column.sortable ? sortRows(column.field) : null
                          }
                          className={`${styles.Table__Header__Cell}`}
                          IconComponent={() =>
                            rowsOrder[0] === column.field ? (
                              rowsOrder[1] === 'asc' ? (
                                <IconWrapper
                                  iconName="chevron-up"
                                  className={`${styles.Table__TH__Icon}`}
                                />
                              ) : (
                                <IconWrapper
                                  iconName="chevron-down"
                                  className={`${styles.Table__TH__Icon}`}
                                />
                              )
                            ) : (
                              <div style={{ height: 32, width: 19 }}></div>
                            )
                          }
                        >
                          <div> {column.title}</div>
                        </TableSortLabel>
                      </TableCell>
                    ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {(storedRows || []).map((row) => (
                  <TableRow
                    key={ `invoices_periods_table_row_${row.period}_${row.index}`}
                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    style={{ height: 100 }}
                    onClick={() =>
                      dispatch(RIGHT_DRAWER.SetDrawer({
                        type: 'INVOICES_PERIOD_DETAILS',
                        drawerConfig: {
                          data: row,
                          oldData: rightDrawer.drawerConfig,
                        }
                      } as any) as any)
                    }
                    className={`${styles.Table__Body__Row__Clickable}`}
                  >
                    <TableCell
                      className={`${
                        !columns?.[0]?.sortable === true &&
                        styles.Table__Cell__Static
                      }`}
                      key={`invoices_periods_table_row_${
                        row.period
                      }_cell_0_`}
                      component="th"
                      scope="row"
                    >
                      <div className={`${styles.Table__Cell__InvoicesPeriod__Period}`}>
                        <span>{row.period}</span>
                        <span className={`${styles.Table__Cell__InvoicesPeriod__Period__Due}`}>
                          {t('widgets.tables.utils.due_date')}: {formatHumanDate(row.sites[0].due_date)}
                        </span>
                      </div>
                    </TableCell>

                    <TableCell
                      key={`invoices_periods_table_row_${row.period}_cell_1`}
                      component="th"
                      scope="row"
                    >
                      <div
                        className={`${
                          !columns?.[0]?.sortable === true &&
                          styles.Table__Cell__Static
                        }`}
                      >
                        <p
                          className={`${styles.Table__Cell__InvoicesPeriod__Amount}`}
                        >
                          {' '}
                          {row?.amount ? formatToMaxFourDigits(row?.amount) : 0}
                        </p>
                      </div>
                    </TableCell>

                    <TableCell
                      className={`${
                        !columns?.[1]?.sortable === true &&
                        styles.Table__Cell__Static
                      }`}
                      key={`invoices_periods_table_row_${row.period}_cell_2`}
                      component="th"
                      scope="row"
                    >
                      <div>
                        <p
                          className={`${styles.Table__Cell__InvoicesPeriod__Received}`}
                        >
                          {' '}
                          {row?.received ? formatToMaxFourDigits(row?.received) : 0}
                        </p>
                      </div>
                    </TableCell>

                    <TableCell
                      className={`${
                        !columns?.[3]?.sortable === true &&
                        styles.Table__Cell__Static
                      }`}
                      key={`invoices_periods_table_row_${row.period}_cell_4`}
                      component="th"
                      scope="row"
                    >
                      <div>
                        <div>
                          <p
                            className={`${styles.Table__Cell__InvoicesPeriod__Paid}`}
                          >
                            {' '}
                            {row?.paid ? row?.paid : ''} {t('widgets.tables.utils.paid')}
                          </p>
                          {/* <p className={ `${styles.Table__Cell__Community__Status}`} > {row?.status || false }</p> */}
                        </div>
                      </div>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>

              <TableFooter>
                <TableRow>
                  <TableCell
                    align="left"
                    className={`${
                      columns[0].sortable &&
                      styles.Table__Footer__Cell__Clickable
                    }`}
                  >
                    <div
                      onClick={() =>
                        columns[0].sortable ? sortRows('period') : null
                      }
                      className={`${
                        columns[0].sortable && rowsOrder[0] === 'period'
                          ? styles.Table__Footer__Cell__Active
                          : styles.Table__Footer__Cell
                      }`}
                        >
                          {storedRows.length}
                          { ' ' }
                          {
                            storedRows.length === 1
                            ? t('widgets.tables.utils.total_period')
                            : t('widgets.tables.utils.total_periods')
                          }
                          

                      {rowsOrder[0] === 'period' ? (
                        rowsOrder[1] === 'asc' ? (
                          <IconWrapper
                            iconName="chevron-up"
                            className={`${styles.Table__TH__Icon}`}
                          />
                        ) : (
                          <IconWrapper
                            iconName="chevron-down"
                            className={`${styles.Table__TH__Icon}`}
                          />
                        )
                      ) : (
                        <div style={{ height: 32, width: 19 }}></div>
                      )}
                    </div>
                  </TableCell>
                  <TableCell
                    align="left"
                    className={`${
                      columns[1].sortable &&
                      styles.Table__Footer__Cell__Clickable
                    }`}
                  >
                    <div
                          onClick={() =>
                            columns[1].sortable ? sortRows('amount') : null
                          }
                          className={`${columns[1].sortable && rowsOrder[0] === 'amount'
                              ? styles.Table__Footer__Cell__Active
                              : styles.Table__Footer__Cell
                            }`}
                          
                        >

                            {formatToMaxFourDigits(storedRows.reduce((acc: number, row: any) => acc + row.amount, 0))}
                          { ' ' }
                          {t('widgets.tables.utils.total_due')}
                          
                      {rowsOrder[0] === 'amount' ? (
                        rowsOrder[1] === 'asc' ? (
                          <IconWrapper
                            iconName="chevron-up"
                            className={`${styles.Table__TH__Icon}`}
                          />
                        ) : (
                          <IconWrapper
                            iconName="chevron-down"
                            className={`${styles.Table__TH__Icon}`}
                          />
                        )
                      ) : (
                        <div style={{ height: 32, width: 19 }}></div>
                      )}
                    </div>
                  </TableCell>
                  <TableCell
                    align="left"
                    className={`${
                      columns[2].sortable &&
                      styles.Table__Footer__Cell__Clickable
                    }`}
                  >
                    <div
                      onClick={() =>
                        columns[2].sortable ? sortRows('received') : null
                      }
                      className={`${
                        columns[2].sortable && rowsOrder[0] === 'received'
                          ? styles.Table__Footer__Cell__Active
                          : styles.Table__Footer__Cell
                      }`}
                        >

                          {formatToMaxFourDigits(storedRows.reduce((acc: number, row: any) => acc + row.received, 0))}
                          { ' ' }
                          {t('widgets.tables.utils.total_received')}
                          
                      {rowsOrder[0] === 'received' ? (
                        rowsOrder[1] === 'asc' ? (
                          <IconWrapper
                            iconName="chevron-up"
                            className={`${styles.Table__TH__Icon}`}
                          />
                        ) : (
                          <IconWrapper
                            iconName="chevron-down"
                            className={`${styles.Table__TH__Icon}`}
                          />
                        )
                      ) : (
                        <div style={{ height: 32, width: 19 }}></div>
                      )}
                    </div>
                  </TableCell>
                  <TableCell align="left"></TableCell>
                </TableRow>
              </TableFooter>
            </Table>
          </TableContainer>
        </div>
        </div>
      ) : (
        <div
          className={`${styles.Table} mb-3`}
        >
          <div className={`${styles.Table__Title}`}>{title}</div>
          <div className={`${styles.Table__NO_DATA}`}> {no_data_text}</div>
        </div>
      )}
    </div>
  );
}

export default InvoicesPeriodTable;
